var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "liveForm",
          attrs: {
            model: _vm.liveForm,
            rules: _vm.rules,
            "label-width": "160px",
            "validate-on-rule-change": false,
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "直播时间：", prop: "liveTime" } },
            [
              _c("el-date-picker", {
                attrs: {
                  size: "small",
                  clearable: "",
                  type: "datetimerange",
                  format: "yyyy-MM-dd HH:mm",
                  "value-format": "yyyy-MM-dd HH:mm:ss",
                  "picker-options": _vm.pickerOptions,
                  "range-separator": "至",
                  "start-placeholder": "直播开始日期",
                  "end-placeholder": "直播结束日期",
                  "default-time": ["00:00:00", "23:59:59"],
                },
                model: {
                  value: _vm.liveForm.liveTime,
                  callback: function ($$v) {
                    _vm.$set(_vm.liveForm, "liveTime", $$v)
                  },
                  expression: "liveForm.liveTime",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "队伍信息：", prop: "teamA" } },
            [
              _c("div", { staticClass: "teamInfo" }, [
                _c(
                  "div",
                  { staticClass: "left" },
                  [
                    _c("el-input", {
                      attrs: {
                        maxlength: "99",
                        size: "small",
                        clearable: "",
                        placeholder: "输入文案",
                      },
                      model: {
                        value: _vm.liveForm.teamA,
                        callback: function ($$v) {
                          _vm.$set(_vm.liveForm, "teamA", $$v)
                        },
                        expression: "liveForm.teamA",
                      },
                    }),
                    _c("el-input", {
                      attrs: {
                        size: "small",
                        clearable: "",
                        placeholder: "输入数字",
                      },
                      model: {
                        value: _vm.liveForm.teamAScore,
                        callback: function ($$v) {
                          _vm.$set(_vm.liveForm, "teamAScore", $$v)
                        },
                        expression: "liveForm.teamAScore",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "right" },
                  [
                    _c(
                      "el-upload",
                      {
                        staticClass: "avatar-uploader",
                        attrs: {
                          "before-upload": _vm.fileCheck,
                          "http-request": (params) => _vm.upload(params, 1),
                          "show-file-list": false,
                        },
                      },
                      [
                        _vm.liveForm.teamAImg
                          ? _c("el-image", {
                              staticClass: "avatar",
                              attrs: {
                                src: _vm.liveForm.teamAImg,
                                fit: "contain",
                              },
                            })
                          : _c("i", {
                              staticClass: "el-icon-plus avatar-uploader-icon",
                            }),
                      ],
                      1
                    ),
                    _c(
                      "el-radio-group",
                      {
                        model: {
                          value: _vm.liveForm.teamAImgSelectWidth,
                          callback: function ($$v) {
                            _vm.$set(_vm.liveForm, "teamAImgSelectWidth", $$v)
                          },
                          expression: "liveForm.teamAImgSelectWidth",
                        },
                      },
                      [
                        _c("el-radio", { attrs: { label: "300" } }, [
                          _vm._v("小图：300px (推荐)"),
                        ]),
                        _c("el-radio", { attrs: { label: "700" } }, [
                          _vm._v("大图：700px (推荐)"),
                        ]),
                        _c(
                          "el-radio",
                          { staticClass: "custom-width", attrs: { label: -1 } },
                          [
                            _vm._v("自定义图片宽度\n              "),
                            _c(
                              "el-popover",
                              {
                                attrs: {
                                  placement: "top",
                                  width: "200",
                                  trigger: "hover",
                                  content:
                                    "如果输入了自定义图片宽度，以自定义图片宽度为准",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-question tip-icon",
                                  staticStyle: { color: "#507dc5" },
                                  attrs: { slot: "reference" },
                                  slot: "reference",
                                }),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.liveForm.teamAImgSelectWidth === -1
                      ? _c("el-input", {
                          attrs: {
                            size: "small",
                            placeholder: "请输入图片宽度(单位px)",
                            clearable: "",
                          },
                          model: {
                            value: _vm.liveForm.teamAImgWidth,
                            callback: function ($$v) {
                              _vm.$set(_vm.liveForm, "teamAImgWidth", $$v)
                            },
                            expression: "liveForm.teamAImgWidth",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ]
          ),
          _c("el-form-item", { attrs: { label: " ", prop: "teamB" } }, [
            _c("div", { staticClass: "teamInfo" }, [
              _c(
                "div",
                { staticClass: "left" },
                [
                  _c("el-input", {
                    attrs: {
                      maxlength: "99",
                      size: "small",
                      clearable: "",
                      placeholder: "输入文案",
                    },
                    model: {
                      value: _vm.liveForm.teamB,
                      callback: function ($$v) {
                        _vm.$set(_vm.liveForm, "teamB", $$v)
                      },
                      expression: "liveForm.teamB",
                    },
                  }),
                  _c("el-input", {
                    attrs: {
                      size: "small",
                      clearable: "",
                      placeholder: "输入数字",
                    },
                    model: {
                      value: _vm.liveForm.teamBScore,
                      callback: function ($$v) {
                        _vm.$set(_vm.liveForm, "teamBScore", $$v)
                      },
                      expression: "liveForm.teamBScore",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "right" },
                [
                  _c(
                    "el-upload",
                    {
                      staticClass: "avatar-uploader",
                      attrs: {
                        "before-upload": _vm.fileCheck,
                        "http-request": (params) => _vm.upload(params, 2),
                        "show-file-list": false,
                      },
                    },
                    [
                      _vm.liveForm.teamBImg
                        ? _c("el-image", {
                            staticClass: "avatar",
                            attrs: {
                              src: _vm.liveForm.teamBImg,
                              fit: "contain",
                            },
                          })
                        : _c("i", {
                            staticClass: "el-icon-plus avatar-uploader-icon",
                          }),
                    ],
                    1
                  ),
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.liveForm.teamBImgSelectWidth,
                        callback: function ($$v) {
                          _vm.$set(_vm.liveForm, "teamBImgSelectWidth", $$v)
                        },
                        expression: "liveForm.teamBImgSelectWidth",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "300" } }, [
                        _vm._v("小图：300px (推荐)"),
                      ]),
                      _c("el-radio", { attrs: { label: "700" } }, [
                        _vm._v("大图：700px (推荐)"),
                      ]),
                      _c(
                        "el-radio",
                        { staticClass: "custom-width", attrs: { label: -1 } },
                        [
                          _vm._v("自定义图片宽度\n              "),
                          _c(
                            "el-popover",
                            {
                              attrs: {
                                placement: "top",
                                width: "200",
                                trigger: "hover",
                                content:
                                  "如果输入了自定义图片宽度，以自定义图片宽度为准",
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-question tip-icon",
                                staticStyle: { color: "#507dc5" },
                                attrs: { slot: "reference" },
                                slot: "reference",
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.liveForm.teamBImgSelectWidth === -1
                    ? _c("el-input", {
                        attrs: {
                          size: "small",
                          placeholder: "请输入图片宽度(单位px)",
                          clearable: "",
                        },
                        model: {
                          value: _vm.liveForm.teamBImgWidth,
                          callback: function ($$v) {
                            _vm.$set(_vm.liveForm, "teamBImgWidth", $$v)
                          },
                          expression: "liveForm.teamBImgWidth",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]),
          ]),
          _c(
            "el-form-item",
            { attrs: { label: "显示顺序：", prop: "displayOrder" } },
            [
              _c("el-input", {
                attrs: {
                  size: "small",
                  clearable: "",
                  placeholder: "按照顺序进行显示，相同数字按时间排序",
                },
                model: {
                  value: _vm.liveForm.displayOrder,
                  callback: function ($$v) {
                    _vm.$set(_vm.liveForm, "displayOrder", $$v)
                  },
                  expression: "liveForm.displayOrder",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "描述：", prop: "description" } },
            [
              _c("el-input", {
                attrs: {
                  maxlength: "99",
                  size: "small",
                  clearable: "",
                  placeholder: "输入文案",
                },
                model: {
                  value: _vm.liveForm.description,
                  callback: function ($$v) {
                    _vm.$set(_vm.liveForm, "description", $$v)
                  },
                  expression: "liveForm.description",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "关联应用：", prop: "thirdPartyAppId" } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    size: "small",
                    clearable: "",
                    placeholder: "请选择",
                  },
                  model: {
                    value: _vm.liveForm.thirdPartyAppId,
                    callback: function ($$v) {
                      _vm.$set(_vm.liveForm, "thirdPartyAppId", $$v)
                    },
                    expression: "liveForm.thirdPartyAppId",
                  },
                },
                _vm._l(_vm.thirdPartyAppList.value, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c("el-form-item", { attrs: { label: "单片跳转链接：" } }, [
            _c("br"),
          ]),
          _c(
            "div",
            { staticClass: "link-container" },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Android_Scheme：", prop: "androidScheme" } },
                [
                  _c("el-input", {
                    attrs: {
                      maxlength: "999",
                      size: "small",
                      clearable: "",
                      placeholder: "输入Android端的Scheme链接",
                    },
                    model: {
                      value: _vm.liveForm.androidScheme,
                      callback: function ($$v) {
                        _vm.$set(_vm.liveForm, "androidScheme", $$v)
                      },
                      expression: "liveForm.androidScheme",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "Android_app_link：",
                    prop: "androidAppLink",
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      maxlength: "999",
                      size: "small",
                      clearable: "",
                      placeholder: "输入Android端的通用跳转链接",
                    },
                    model: {
                      value: _vm.liveForm.androidAppLink,
                      callback: function ($$v) {
                        _vm.$set(_vm.liveForm, "androidAppLink", $$v)
                      },
                      expression: "liveForm.androidAppLink",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "Android_pad_Scheme：",
                    prop: "androidPadScheme",
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      maxlength: "999",
                      size: "small",
                      clearable: "",
                      placeholder: "输入Android_pad端的Scheme链接",
                    },
                    model: {
                      value: _vm.liveForm.androidPadScheme,
                      callback: function ($$v) {
                        _vm.$set(_vm.liveForm, "androidPadScheme", $$v)
                      },
                      expression: "liveForm.androidPadScheme",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("br"),
          _c(
            "div",
            { staticClass: "link-container" },
            [
              _c(
                "el-form-item",
                { attrs: { label: "iOS_Scheme：", prop: "iosScheme" } },
                [
                  _c("el-input", {
                    attrs: {
                      maxlength: "999",
                      size: "small",
                      clearable: "",
                      placeholder: "输入iOS端的Scheme链接",
                    },
                    model: {
                      value: _vm.liveForm.iosScheme,
                      callback: function ($$v) {
                        _vm.$set(_vm.liveForm, "iosScheme", $$v)
                      },
                      expression: "liveForm.iosScheme",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "iOS_app_link：", prop: "appLink" } },
                [
                  _c("el-input", {
                    attrs: {
                      maxlength: "999",
                      size: "small",
                      clearable: "",
                      placeholder: "输入iOS端的通用跳转链接",
                    },
                    model: {
                      value: _vm.liveForm.appLink,
                      callback: function ($$v) {
                        _vm.$set(_vm.liveForm, "appLink", $$v)
                      },
                      expression: "liveForm.appLink",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "iPad_Scheme：", prop: "ipadScheme" } },
                [
                  _c("el-input", {
                    attrs: {
                      maxlength: "999",
                      size: "small",
                      clearable: "",
                      placeholder: "输入ipad端的Scheme链接",
                    },
                    model: {
                      value: _vm.liveForm.ipadScheme,
                      callback: function ($$v) {
                        _vm.$set(_vm.liveForm, "ipadScheme", $$v)
                      },
                      expression: "liveForm.ipadScheme",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("br"),
          _c(
            "el-form-item",
            { attrs: { label: "备注", prop: "remark" } },
            [
              _c("el-input", {
                attrs: {
                  "show-word-limit": "",
                  maxlength: "9999",
                  type: "textarea",
                  size: "small",
                  placeholder: "请输入备注",
                  clearable: "",
                },
                model: {
                  value: _vm.liveForm.remark,
                  callback: function ($$v) {
                    _vm.$set(_vm.liveForm, "remark", $$v)
                  },
                  expression: "liveForm.remark",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "状态", prop: "status" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.liveForm.status,
                    callback: function ($$v) {
                      _vm.$set(_vm.liveForm, "status", $$v)
                    },
                    expression: "liveForm.status",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: 1 } }, [_vm._v("生效")]),
                  _c("el-radio", { attrs: { label: 0 } }, [_vm._v("失效")]),
                ],
                1
              ),
            ],
            1
          ),
          _vm.liveForm.status === 1
            ? _c(
                "el-form-item",
                { attrs: { label: "选择", prop: "effectMode" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.liveForm.effectMode,
                        callback: function ($$v) {
                          _vm.$set(_vm.liveForm, "effectMode", $$v)
                        },
                        expression: "liveForm.effectMode",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("立即生效"),
                      ]),
                      _c("el-radio", { attrs: { label: 2 } }, [
                        _vm._v("指定时间生效"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.liveForm.status === 1 && _vm.liveForm.effectMode === 2
            ? _c(
                "el-form-item",
                { attrs: { label: "生效时间", prop: "effectTime" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      size: "small",
                      "picker-options": {
                        disabledDate(time) {
                          return time.getTime() < Date.now() - 8.64e7
                        },
                      },
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      type: "datetimerange",
                      "range-separator": "至",
                      "start-placeholder": "生效开始时间",
                      "end-placeholder": "生效结束时间",
                      clearable: "",
                    },
                    model: {
                      value: _vm.liveForm.effectTime,
                      callback: function ($$v) {
                        _vm.$set(_vm.liveForm, "effectTime", $$v)
                      },
                      expression: "liveForm.effectTime",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "btn-container",
              staticStyle: { "text-align": "right", "margin-top": "20px" },
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.save },
                },
                [_vm._v("保存")]
              ),
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.cancel } },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }